/* P.Louise — Flavour bundle picker
 * Search/filter, mix & match bundle pricing, and a Shopify cart/add.js
 * powered "Add to bag" for the flavour variant grid.
 */
(function () {
  const SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2);
    const [whole, decimal] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDecimals = decimal === '00' ? withCommas : `${withCommas}.${decimal}`;
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = (format || '${{amount}}').match(placeholder);
    const key = match ? match[1] : 'amount';
    const amount = key === 'amount_no_decimals' ? whole
      : key === 'amount_with_comma_separator' ? `${withCommas},${decimal}`
      : key === 'amount_no_decimals_with_comma_separator' ? withCommas
      : `${withCommas}.${decimal}`;
    return (format || '${{amount}}').replace(placeholder, amount);
  }

  class FlavourBundlePicker {
    constructor(root) {
      this.root = root;
      this.bundleSize = parseInt(root.dataset.bundleSize, 10) || 3;
      this.bundlePrice = parseInt(root.dataset.bundlePrice, 10) || 0;
      this.unitPrice = parseInt(root.dataset.unitPrice, 10) || 0;
      this.moneyFormat = root.dataset.moneyFormat;

      this.grid = root.querySelector('[data-fbp-grid]');
      this.tiles = Array.from(root.querySelectorAll('[data-fbp-tile]'));
      this.empty = root.querySelector('[data-fbp-empty]');
      this.countline = root.querySelector('[data-fbp-countline]');
      this.clearBtn = root.querySelector('[data-fbp-clear]');
      this.picksEl = root.querySelector('[data-fbp-picks]');
      this.placeholders = Array.from(root.querySelectorAll('[data-fbp-placeholder]'));
      this.fullPriceEl = root.querySelector('[data-fbp-fullprice]');
      this.priceEl = root.querySelector('[data-fbp-price]');
      this.saveEl = root.querySelector('[data-fbp-save]');
      this.nudgeEl = root.querySelector('[data-fbp-nudge]');
      this.cta = root.querySelector('[data-fbp-cta]');
      this.toast = root.querySelector('[data-fbp-toast]');
      this.toastInner = root.querySelector('[data-fbp-toast-inner]');

      this.carousel = root.querySelector('[data-fbp-carousel]');
      this.carouselTrack = root.querySelector('[data-fbp-carousel-track]');
      this.carouselSlides = Array.from(root.querySelectorAll('[data-fbp-slide]'));
      this.carouselPrev = root.querySelector('[data-fbp-carousel-prev]');
      this.carouselNext = root.querySelector('[data-fbp-carousel-next]');
      this.carouselIndex = 0;

      this.picks = []; // array of variant id strings, duplicates allowed

      this.initSwatches();
      this.bind();
      this.render();
      this.goToSlide(0);
    }

    initSwatches() {
      this.root.querySelectorAll('img.fbp-swatch').forEach((img) => {
        img.addEventListener('error', () => {
          if (!img.dataset.fbTried) {
            img.dataset.fbTried = '1';
            const fb = img.dataset.fallback;
            if (fb) { img.src = fb; return; }
          }
          img.style.display = 'none';
          const ring = img.parentNode;
          if (ring) {
            ring.classList.add('fbp-tile__ring--color-fallback');
            ring.style.setProperty('--fbp-swatch-color', img.dataset.color || '#FF7DB4');
          }
        });
      });
    }

    bind() {
      this.tiles.forEach((tile) => {
        tile.addEventListener('click', (e) => {
          if (tile.hasAttribute('data-unavailable')) return;
          if (e.target.closest('[data-fbp-stepper]')) return;
          this.add(tile.dataset.variantId);
        });
        tile.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!tile.hasAttribute('data-unavailable') && !e.target.closest('[data-fbp-stepper]')) {
              this.add(tile.dataset.variantId);
            }
          }
        });
      });

      this.grid.addEventListener('click', (e) => {
        const minus = e.target.closest('[data-fbp-stepper-minus]');
        const plus = e.target.closest('[data-fbp-stepper-plus]');
        if (minus) { e.stopPropagation(); this.removeOne(minus.dataset.fbpStepperMinus); }
        if (plus)  { e.stopPropagation(); this.add(plus.dataset.fbpStepperPlus); }
      });

      this.clearBtn.addEventListener('click', () => {
        this.picks = [];
        this.render();
      });

      this.cta.addEventListener('click', () => this.addToCart());


      if (this.carouselPrev) {
        this.carouselPrev.addEventListener('click', () => this.goToSlide(this.carouselIndex - 1));
      }
      if (this.carouselNext) {
        this.carouselNext.addEventListener('click', () => this.goToSlide(this.carouselIndex + 1));
      }
      if (this.carousel) {
        let touchStartX = 0;
        this.carousel.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        this.carousel.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) this.goToSlide(this.carouselIndex + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      this.filter();
    }

    findTile(variantId) {
      return this.tiles.find((t) => t.dataset.variantId === variantId);
    }

    goToSlide(index) {
      const count = this.carouselSlides.length;
      if (!count) return;
      const clamped = ((index % count) + count) % count;
      this.carouselIndex = clamped;
      if (this.carouselTrack) {
        this.carouselTrack.style.transform = `translateX(-${clamped * 100}%)`;
      }
    }

    goToVariantImage(variantId) {
      const tile = this.findTile(variantId);
      if (!tile || !tile.dataset.imageId) return;
      const index = this.carouselSlides.findIndex((slide) => slide.dataset.imageId === tile.dataset.imageId);
      if (index >= 0) this.goToSlide(index);
    }

    add(variantId) {
      this.picks.push(variantId);
      this.goToVariantImage(variantId);
      this.render();
    }

    removeOne(variantId) {
      const i = this.picks.lastIndexOf(variantId);
      if (i < 0) return;
      this.picks.splice(i, 1);
      this.render();
    }

    removeAt(index) {
      this.picks.splice(index, 1);
      this.render();
    }

    countOf(variantId) {
      return this.picks.filter((id) => id === variantId).length;
    }

    filter() {
      let visible = 0;
      this.tiles.forEach((tile) => {
        tile.hidden = false;
        visible += 1;
      });

      this.empty.classList.toggle('is-visible', visible === 0);

      const label = visible === 1 ? 'Option' : 'Options';
      this.countline.textContent = `${visible} ${label}`;
    }

    renderTiles() {
      this.tiles.forEach((tile) => {
        const id = tile.dataset.variantId;
        const count = this.countOf(id);
        const selected = count > 0;
        const badge = tile.querySelector('[data-fbp-tile-badge]');
        tile.classList.toggle('is-selected', selected);
        if (selected) {
          badge.innerHTML =
            `<button type="button" class="fbp-tile__stepper-btn" data-fbp-stepper data-fbp-stepper-minus="${id}" aria-label="Remove one ${tile.dataset.name}">−</button>` +
            `<span class="fbp-tile__stepper-count">${count}</span>` +
            `<button type="button" class="fbp-tile__stepper-btn" data-fbp-stepper data-fbp-stepper-plus="${id}" aria-label="Add another ${tile.dataset.name}">+</button>`;
        } else {
          badge.innerHTML = '';
        }
      });
    }

    buildSwatch(tile, size) {
      const color = tile ? (tile.dataset.swatchColor || '#FF7DB4') : '#FF7DB4';
      const src = tile ? (tile.dataset.swatchSrc || tile.dataset.image || '') : '';
      const fallback = tile ? (tile.dataset.image || '') : '';
      const light = tile && tile.dataset.light === 'true';

      const img = document.createElement('img');
      img.className = 'fbp-swatch' + (light ? ' fbp-swatch--light' : '');
      img.alt = tile ? (tile.dataset.name || '') : '';
      img.style.width = `${size}px`;
      img.style.height = `${size}px`;
      img.dataset.fallback = fallback;
      img.dataset.color = color;
      img.addEventListener('error', () => {
        if (!img.dataset.fbTried) {
          img.dataset.fbTried = '1';
          if (fallback && img.src !== fallback) { img.src = fallback; return; }
        }
        img.style.display = 'none';
        const ring = img.parentNode;
        if (ring) {
          ring.classList.add('fbp-tile__ring--color-fallback');
          ring.style.setProperty('--fbp-swatch-color', color);
        }
      });
      img.src = src;
      return img;
    }

    renderFooter() {
      const count = this.picks.length;
      const completeBundles = Math.floor(count / this.bundleSize);
      const remainder = count % this.bundleSize;
      const toNext = remainder === 0 ? 0 : this.bundleSize - remainder;
      const bundlePerItem = Math.round(this.bundlePrice / this.bundleSize);

      // Once the first bundle of 3 is unlocked every additional item costs the
      // per-bundle rate (e.g. £9) rather than the full unit price.
      let price;
      if (count < this.bundleSize) {
        price = count * this.unitPrice;
      } else {
        price = this.bundlePrice + (count - this.bundleSize) * bundlePerItem;
      }

      const fullPrice = count * this.unitPrice;
      const savings = fullPrice - price;
      const perBundleSave = this.unitPrice * this.bundleSize - this.bundlePrice;

      // Picks row
      this.picksEl.innerHTML = '';
      if (count === 0) {
        this.placeholders.forEach((ph) => this.picksEl.appendChild(ph));
      } else {
        this.picks.forEach((variantId, index) => {
          const tile = this.findTile(variantId);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'fbp-pick';
          button.setAttribute('aria-label', `Remove ${tile ? tile.dataset.name : 'item'}`);
          button.appendChild(this.buildSwatch(tile, 38));
          const remove = document.createElement('span');
          remove.className = 'fbp-pick__remove';
          remove.innerHTML = SVG_X;
          button.appendChild(remove);
          button.addEventListener('click', () => this.removeAt(index));
          this.picksEl.appendChild(button);
        });
      }

      // Price
      this.priceEl.textContent = formatMoney(count === 0 ? 0 : price, this.moneyFormat);
      this.priceEl.classList.toggle('has-savings', savings > 0);
      if (savings > 0) {
        this.fullPriceEl.textContent = formatMoney(fullPrice, this.moneyFormat);
        this.fullPriceEl.style.display = '';
        this.saveEl.textContent = `Save ${formatMoney(savings, this.moneyFormat)}`;
        this.saveEl.style.display = '';
      } else {
        this.fullPriceEl.style.display = 'none';
        this.saveEl.style.display = 'none';
      }

      // Nudge
      const bundleMoney = formatMoney(this.bundlePrice, this.moneyFormat);
      if (count === 0) {
        this.nudgeEl.innerHTML = `Mix &amp; match — <strong>any ${this.bundleSize} for ${bundleMoney}</strong>`;
      } else if (count < this.bundleSize) {
        const saveMoney = formatMoney(perBundleSave, this.moneyFormat);
        this.nudgeEl.innerHTML = `Add <span class="fbp-nudge__accent">${toNext} more</span> → ${this.bundleSize} for ${bundleMoney} · save ${saveMoney} 🔥`;
      } else {
        const saveMoney = formatMoney(savings, this.moneyFormat);
        const extraMoney = formatMoney(bundlePerItem, this.moneyFormat);
        this.nudgeEl.innerHTML = `<span class="fbp-nudge__accent">Bundle unlocked!</span> You save ${saveMoney} 🎉 · <span class="fbp-nudge__extra">+${extraMoney} per extra flavour</span>`;
      }

      // CTA
      this.cta.disabled = count === 0;
      this.cta.textContent = count === 0
        ? this.cta.dataset.emptyLabel || 'Pick a flavour'
        : `Add to bag · ${formatMoney(price, this.moneyFormat)}`;

      // Clear button
      this.clearBtn.hidden = count === 0;
    }

    render() {
      this.renderTiles();
      this.renderFooter();
    }

    showToast(message) {
      this.toastInner.textContent = message;
      this.toast.classList.add('is-visible');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.classList.remove('is-visible');
      }, 2200);
    }

    addToCart() {
      if (this.picks.length === 0 || this.cta.disabled) return;

      const quantities = {};
      this.picks.forEach((id) => {
        quantities[id] = (quantities[id] || 0) + 1;
      });
      const items = Object.keys(quantities).map((id) => ({
        id: parseInt(id, 10),
        quantity: quantities[id],
      }));

      this.cta.disabled = true;
      const originalLabel = this.cta.textContent;
      this.cta.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) return response.json().then((err) => Promise.reject(err));
          return response.json();
        })
        .then((data) => {
          this.picks = [];
          this.render();
          this.showToast('Added to your bag!');
          document.dispatchEvent(new CustomEvent('fbp:added-to-cart', { detail: data, bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch((err) => {
          const message = (err && err.description) || 'Something went wrong — please try again.';
          this.showToast(message);
          this.cta.disabled = false;
          this.cta.textContent = originalLabel;
        });
    }
  }

  function init() {
    document.querySelectorAll('[data-flavour-bundle-picker]').forEach((root) => {
      if (root.__fbpInitialised) return;
      root.__fbpInitialised = true;
      new FlavourBundlePicker(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();